import React, { useState } from 'react';
import { FaRegWindowClose, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// LightboxModal Component
const LightboxModal = ({ image, onClose, onNext, onPrevious, hasNext, hasPrevious }) => {
    const [scale, setScale] = useState(1);
    const [rotate, setRotate] = useState(0);

    const zoomIn = () => setScale(scale + 0.2);
    const zoomOut = () => setScale(scale > 0.2 ? scale - 0.2 : scale);
    const rotateLeft = () => setRotate((prev) => (prev - 90) % 360);
    const rotateRight = () => setRotate((prev) => (prev + 90) % 360);

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50 p-4 backdrop-blur-sm">
            <div className="relative bg-white p-4 rounded-lg shadow-lg max-w-[40rem] max-h-full ">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-white text-3xl  hover:bg-richblack-900 rounded-full p-2 flex items-center justify-center z-50"
                >
                    <FaRegWindowClose />
                </button>
                {hasPrevious && (
                    <button
                        onClick={onPrevious}
                        className="absolute top-1/2 left-4 transform -translate-y-1/2 text-white text-3xl bg-richblack-800 hover:bg-richblack-900 rounded-full p-2 flex items-center justify-center z-50"
                    >
                        <FaChevronLeft />
                    </button>
                )}
                <div className="relative">
                    <img
                        src={image}
                        alt="Lightbox"
                        style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                        className="max-w-full max-h-[80vh] object-cover"
                    />
                </div>
                {hasNext && (
                    <button
                        onClick={onNext}
                        className="absolute top-1/2 right-4 transform -translate-y-1/2 text-white text-3xl bg-richblack-800 hover:bg-richblack-900 rounded-full p-2 flex items-center justify-center z-50"
                    >
                        <FaChevronRight />
                    </button>
                )}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-50">
                    <button
                        onClick={zoomIn}
                        className="bg-blue-600  text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
                    >
                        Zoom In
                    </button>
                    <button
                        onClick={zoomOut}
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
                    >
                        Zoom Out
                    </button>
                    <button
                        onClick={rotateLeft}
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
                    >
                        Rotate Left
                    </button>
                    <button
                        onClick={rotateRight}
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
                    >
                        Rotate Right
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LightboxModal;
